export default __webpack_public_path__ + "static/media/office2.8b6bd27c.jpg";